module.exports = __webpack_public_path__ + "img/exhibition-2-title@2x.d3cacb3f.png";